import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './about.scss';
import { getBanner, getCompany } from '@/api/user';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class About extends React.Component{
	constructor (props) {
		super(props);
		this.state={
			timestep: [
				{
					year: 2018,
					monthList: [
					]
				},
				{
					year: 2017,
					monthList: [
						{
							month: 12,
							contentList: [
								'上海亦立文化传媒有限公司成立'
							]
						},
						{
							month: 11,
							contentList: [
								'杭州亦盛文化传媒有限公司成立'
							]
						},
						{
							month: 5,
							contentList: [
								'上海亦立文化传媒有限公司成立',
								'上海亦立文化传媒有限公司成立'
							]
						}
					]
				},
				{
					year: 2016,
					monthList: [
						{
							month: 7,
							contentList: [
								'上海亦立文化传媒有限公司成立'
							]
						},
						{
							month: 6,
							contentList: [
								'杭州亦盛文化传媒有限公司成立'
							]
						},
						{
							month: 5,
							contentList: [
								'上海亦立文化传媒有限公司成立',
								'上海亦立文化传媒有限公司成立'
							]
						}
					]
				},
				{
					year: 2015,
					monthList: [
						{
							month: 7,
							contentList: [
								'上海亦立文化传媒有限公司成立'
							]
						},
						{
							month: 6,
							contentList: [
								'杭州亦盛文化传媒有限公司成立'
							]
						},
						{
							month: 5,
							contentList: [
								'上海亦立文化传媒有限公司成立',
								'上海亦立文化传媒有限公司成立'
							]
						}
					]
				},
				{
					year: 2014,
					monthList: [
						{
							month: 7,
							contentList: [
								'上海亦立文化传媒有限公司成立'
							]
						},
						{
							month: 6,
							contentList: [
								'杭州亦盛文化传媒有限公司成立'
							]
						},
						{
							month: 5,
							contentList: [
								'上海亦立文化传媒有限公司成立',
								'上海亦立文化传媒有限公司成立'
							]
						}
					]
				},
				{
					year: 2013,
					monthList: [
						{
							month: 7,
							contentList: [
								'上海亦立文化传媒有限公司成立'
							]
						},
						{
							month: 6,
							contentList: [
								'杭州亦盛文化传媒有限公司成立'
							]
						},
						{
							month: 5,
							contentList: [
								'上海亦立文化传媒有限公司成立',
								'上海亦立文化传媒有限公司成立'
							]
						}
					]
				},
				{
					year: 2012,
					monthList: [
						{
							month: 7,
							contentList: [
								'上海亦立文化传媒有限公司成立'
							]
						},
						{
							month: 6,
							contentList: [
								'杭州亦盛文化传媒有限公司成立'
							]
						},
						{
							month: 5,
							contentList: [
								'上海亦立文化传媒有限公司成立',
								'上海亦立文化传媒有限公司成立'
							]
						}
					]
				}
			],
			companyName: [],
			clickStep: 0,
			nowIndex: 1,
			nowLeft: 0,
			slideLength: 738
		}
	}
	turnLeft () {
		if (this.state.clickStep === 0) {

		} else {
			this.setState({
				clickStep: this.state.clickStep - 1
			})
		}
		if (this.state.nowIndex - 1 <= 0) {

		} else {
			this.setState({
				nowIndex: this.state.nowIndex - 1,
				nowLeft: this.state.nowLeft + 123
			})
		}
	}
	turnRight () {
		if (this.state.clickStep === (this.state.timestep.length - 1)) {

		} else {
			this.setState({
				clickStep: this.state.clickStep + 1
			})
		}
		if (this.state.nowIndex + 6 > this.state.timestep.length) {

		} else {
			this.setState({
				nowIndex: this.state.nowIndex + 1,
				nowLeft: this.state.nowLeft - 123
			})
		}
	}
	changeClickStep (index) {
		this.setState({
			clickStep: index
		})
	}
	componentDidMount () {
		getBanner({type: 4}).then(res => {
			this.setState({
				banner: res.data.list[0].image
			})
		})
		getCompany().then(res => {
			this.setState({
				timestep: res.data.list,
                companyName: res.data.company
			})
		})
        // getCompany().then(res => {
        //     this.setState({
        //         companyName: res.data.list
        //     })
        // })
		this.setState({
			slideLength: this.state.timestep.length * 123
		})
	}
	render() {
		return(
			<div className='about-us'>
				<div className='banner' style={{backgroundImage: `url(${this.state.banner})`}}>
				</div>
				<div className='home-contain about-company'>
					<div className='about-us--title'>
						公司简介
					</div>
					<span> 亦盛传媒成立于2013年，专注企业的数字效果营销服务。发展至今，旗下拥有八家全资子公司，规模达六百余人。业务涵盖搜索、长视频、短视频、信息流、社交、品牌广告等领域，一直致力于为企业提供一站式互联网营销服务。</span>
					{/* <span> 亦盛传媒成立于2012年（公司前身杭州广桥网络技术有限公司），专注企业的数字效果营销服务。</span>
					<span> 发展至今，业务涵盖搜索、信息流、长视频、短视频、直播投放、品牌广告等领域，一直致力于为企业提供一站式互联网营销服务。亦盛传媒希望不仅仅为广告主带去商机，更希望通过全方位、可依赖的互联网营销解决方案为中小企业发展助阵，建立良性的互联网营销环境，打造多赢生态圈。</span> */}
				</div>
				<div className='common-bg'><div className="gray-center" style={{ padding: 0}}>
					<div className='home-contain about-user'>
						<div className='about-us--title'>
							创始人简介
						</div>
						<div className='about-user--left pull-left'>
							<div className=''>彭毅</div>
							<span>亦盛文化传媒创始人 & CEO</span>
							<span>毕业于浙江大学、理学学士学位</span>
							<span>中欧商学院EMBA</span>
							<span>曾任职于IBM、联想、O2等</span>
							<span>2008年进入互联网数字营销领域</span>
							<span>2012年创办杭州广桥网络技术有限公司（亦盛前）</span>
						</div>
						<div className='about-user--right pull-right'>
							<img src={`${process.env.PUBLIC_URL}/images/pengzong.png`} />
						</div>
						</div>
					</div>
				</div>
					<div className='home-contain time-step'>
						<div className='about-us--title'>
							公司发展历程
						</div>
						<div className='time-step--group'>
							<i className='glyphicon glyphicon-toleft pull-left' onClick={this.turnLeft.bind(this)}></i>
							<div className='slides'>
								<div className='slides-contain' style={{width: this.state.slideLength + 'px',left: this.state.nowLeft + 'px'}}>
									{
										this.state.timestep.map((item, index) => {
											return (
												<div className={`yaer-group ${index === this.state.clickStep ? 'active' : ''}`} key={index}>
													<div className='yaer-number' onClick={this.changeClickStep.bind(this, index)}>{item.year}</div>
													<div className={`${index === this.state.clickStep ? 'big-circle' : 'small-circle'}`}>
														<div className={`${index === this.state.clickStep ? 'big-white' : ''}`}>
															<div className={`${index === this.state.clickStep ? 'big-orange' : ''}`}>
															</div>
														</div>
													</div>
												</div>
											)
										})
									}
								</div>
							</div>
							<i className='glyphicon glyphicon-toright pull-right' onClick={this.turnRight.bind(this)}></i>
						</div>
						<div className='company-description'>
							{
								this.state.timestep[this.state.clickStep].company && this.state.timestep[this.state.clickStep].company.map((item, ind) => {
									return (
										<div className='month-group' key={ind}>
											<div className='month-number'>
												{item.month}月
											</div>
											<div className='content-list'>
												{
													item.company.map((content, i) => {
														return (
															<span key={i}>
																<i className='glyphicon-dalou glyphicon'></i> {content.name}
															</span>
														)
													})
												}
											</div>
										</div>
									)
								})
							}
						</div>
						{/* <div className='children-company'>
							<div className='children-title'>
								集团子公司
							</div>
							<div className='children-list'>
								<div className='pull-left'>
                                    {
                                        this.state.companyName.map((item, ind) => {
                                                    return (
                                                    <span className='pull-name'>{item.name}</span>
                                                    )
                                        })
                                    }
								</div>
							</div>
						</div> */}
					</div>
					<div className='common-bg'>
						<div className="gray-center" style={{padding: 0}}>
						<div className='home-contain about-value'>
							<div className='about-us--title'>
								我们的价值观
							</div>
							<div className='value-list'>
								<div className='value-img--group'>
										<img src={`${process.env.PUBLIC_URL}/images/value-3.png`} />
										{/*<span>开放</span>*/}
									</div>
								<div className='value-img--group'>
									<img src={`${process.env.PUBLIC_URL}/images/value-1.png`} />
									{/*<span>快乐</span>*/}
								</div>
								<div className='value-img--group'>
									<img src={`${process.env.PUBLIC_URL}/images/value-2.png`} />
									{/*<span>责任</span>*/}
								</div>
							</div>
						</div>
						</div>
					</div>
					<div className='about-vision' style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/commonbg.png)`}}>
						<div className='about-us--title'>
							公司愿景
						</div>
						<span>成为中国首屈一指的互联网营销服务商</span>
					</div>
				</div>
		)
	}
}
export default About;



// WEBPACK FOOTER //
// ./src/components/about/about.jsx